import { Header as FoundationsHeader } from 'foundations-components/transitional/components/Header';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import { MyAccountPopover } from './MyAccountPopover';
import { useLogo } from '../context/PortalDataContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Header() {
  var _ref, _logo$alt;
  const logo = useLogo();
  return /*#__PURE__*/_jsx(FoundationsHeader, {
    title: logo !== null && logo !== void 0 && logo.src ? /*#__PURE__*/_jsx("img", {
      src: logo.src,
      alt: (_ref = (_logo$alt = logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : logo.name) !== null && _ref !== void 0 ? _ref : 'Logo',
      height: 32
    }) : null,
    tabs: /*#__PURE__*/_jsxs(UIRouterTabs, {
      children: [/*#__PURE__*/_jsx(UIRouterTab, {
        to: "/",
        exact: true,
        title: "Component Examples"
        // @ts-expect-error - typography is not a permitted prop for UIRouterTab
        ,
        typography: "heading-50"
      }), /*#__PURE__*/_jsx(UIRouterTab, {
        to: "/token-explorer",
        title: "Token Explorer"
        // @ts-expect-error - typography is not a permitted prop for UIRouterTab
        ,
        typography: "heading-50"
      }), /*#__PURE__*/_jsx(UIRouterTab, {
        to: "/projects",
        title: "Project POC"
        // @ts-expect-error - typography is not a permitted prop for UIRouterTab
        ,
        typography: "heading-50"
      })]
    }),
    children: /*#__PURE__*/_jsx(MyAccountPopover, {})
  });
}